import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
declare var $;


@Injectable()
export class ProveedoresService {
  public url:string;

  constructor(private http: Http, private constant: ConstantsService, private validatorService: ValidatorService, private errorService:ErrorsService, private authService: AutenticacionService){
    this.url = constant.apiURL;
  }

  public getDefaultSchedule(){
    return {
      'idProveedores': '',
      'clave': '',
      'nombre': '',
      'atencion': '',
      'telefono': '',
      'direccion': '',
      'cp': '',
      'colonia': '',
      'giro': '',
      'rfc': '',
      'nombreBanco': '',
      'numeroCuenta': '',
      'clabeBanco': '',
      'tipo_proveedor': {},
      'activo': 1
    };
  }

  // objeto proveedor simple
  public getProveedores(page){

    // solo paginacion
    if(page)
      return this.http.get(this.url + "/proveedores?paginate=true&page=" + page, this.authService.getAuthHeaders());

      // solo proveedores
    return this.http.get(this.url + "/proveedores?paginate=true", this.authService.getAuthHeaders());
  }

  public getProveedorestoSelect(preffix = '') {
    //Si no trae el prefix utilizamos el servicio público de los proveedores. 
    if(!preffix || preffix.length === 0){
      return this.http.get(`${this.url}/publicos/proveedores?select=true&validarOrigen=false`, this.authService.getAuthHeaders());
    }

    return this.http.get(this.url + preffix + '/proveedores?select=true&validarOrigen=false', this.authService.getAuthHeaders());
  }

  public getProveedoresAndInversionistas(idObras = null, preffix = '') {
    if (!idObras) {
      return this.http.get(this.url + preffix + '/proveedores?filter=true&select=true', this.authService.getAuthHeaders());  
    }
    return this.http.get(this.url + preffix + '/proveedores?select=true&idObras=' + idObras, this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  public searchProveedores(search, page){
    // buscar con paginacion
    if(page)
      return this.http.get(this.url + "/proveedores?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.url + "/proveedores?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  public createProveedor(data){
    return this.http.post(this.url + '/proveedores', data, this.authService.getAuthHeaders());
  }

  public updateProveedor(data, id){
    return this.http.put(this.url + '/proveedores?id=' + id, data, this.authService.getAuthHeaders());
  }

  public deleteProveedor(id){
    return this.http.delete(this.url + '/proveedores/'+id, this.authService.getAuthHeaders());
  }

  public getTiposProveedor(){
    return this.http.get(this.url + '/proveedores/tipo', this.authService.getAuthHeaders());
  }

  public getTiposProveedortoSelect(preffix = '') {
    return this.http.get(this.url + preffix + '/proveedores/tipo?select=true', this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(5, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public export(search) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.url + '/proveedores/exportar?search='+search, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateProveedor(data){
    console.log("validating... ", data);
    
    let error = [];

    // validacion de NOMBRE
    if(!this.validatorService.required(data["nombre"])){
      error["nombre"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["nombre"], 200)){
      error["nombre"] = this.errorService.max(200);
    }
    

    // validacion de DIRECCION
    if(!this.validatorService.required(data["direccion"])){
      error["direccion"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["direccion"], 200)){
      error["direccion"] = this.errorService.max(200);
    }
    
    // validacion de GIRO
    if(!this.validatorService.required(data["giro"])){
      error["giro"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["giro"], 50)){
      error["giro"] = this.errorService.max(50);
    }

    // validacion de RFC
    if(!this.validatorService.required(data["rfc"])){
      error["rfc"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["rfc"], 15)){
      error["rfc"] = this.errorService.max(15);
    }

    // validacion de CURP
    if (this.validatorService.required(data["curp"]) && !this.validatorService.max(data["curp"], 18)){
      error["curp"] = this.errorService.max(18);
    }

    // validacion de NUMERO DE CUENTA
    if(!this.validatorService.required(data["numeroCuenta"])){
      error["numeroCuenta"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["numeroCuenta"], 18)){
      error["numeroCuenta"] = this.errorService.max(18);
    }

    // validacion de CLABE BANCO
    if(!this.validatorService.required(data["clabeBanco"])){
      error["clabeBanco"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["clabeBanco"], 50)){
      error["clabeBanco"] = this.errorService.max(50);
    }

    // validacion de BANCO
    if(!this.validatorService.required(data["nombreBanco"])){
      error["nombreBanco"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["nombreBanco"], 70)){
      error["nombreBanco"] = this.errorService.max(70);
    }

    // validacion de COLONIA
    if(!this.validatorService.required(data["colonia"])){
      error["colonia"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["colonia"], 50)){
      error["colonia"] = this.errorService.max(50);
    }

    // validacion de CODIGO POSTAL
    if(!this.validatorService.required(data["cp"])){
      error["cp"] = this.errorService.required;
    }else if(!this.validatorService.max(data["cp"], 8)){
      error["cp"] = this.errorService.max(8);
    }

    // validacion de TELEFONO
    if(!this.validatorService.required(data["telefono"])){
      error["telefono"] = this.errorService.required;
    }else if(!this.validatorService.max(data["telefono"], 30)){
      error["telefono"] = this.errorService.max(30);
    }

    // validacion de TIPO PROVEEDOR
    if ($.isEmptyObject(data['tipo_proveedor'])) {
      error["tipo_proveedor"] = this.errorService.required;
    }

    // validacion de Regimen Fiscal
    if ($.isEmptyObject(data['regimen_fiscal'])) {
      error["regimen_fiscal"] = this.errorService.required;
    }

    //Validar email
    if(this.validatorService.required(data['email'])){
      var arregloEmails = data['email'].split(";");

      arregloEmails.forEach(email => {
        if(!this.validatorService.email(email.trim())){     
          error["email"] = "El correo o los correos no tienen un formato valido";
        }
      });
    }else{
      error["email"] = this.errorService.required;
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proveedores.service.ts